import { CrawlerSettingsAdvancedInputDto } from '@/config/api-generated/model'
import { object, InferType, string, mixed, bool, ObjectSchema } from 'yup'

export enum CrawlerFormFields {
  url = 'url',
  advanced = 'advanced',
  options = 'options',
  onePage = 'onePage',
  specificRoute = 'specificRoute',
}

export enum CrawlerAdvancedFields {
  // includeBase = "includeBase",
  isAsync = 'isAsync',
  includeSubDomains = 'includeSubDomains',
  includeBroken = 'includeBroken',
  includeExternal = 'includeExternal',
  includeOrphan = 'includeOrphan',
  includeImages = 'includeImages',
  includeFiles = 'includeFiles',
}

export enum BooleanOptions {
  yes = 'yes',
  no = 'no',
}

export const crawlerSettings: ObjectSchema<
  Omit<
    CrawlerSettingsAdvancedInputDto,
    'parse' | 'retries' | 'saveHtml' | 'saveScreenshot' | 'userAgent'
  >
> = object({
  [CrawlerAdvancedFields.isAsync]: bool().optional(),
  [CrawlerAdvancedFields.includeSubDomains]: bool().optional(),
  [CrawlerAdvancedFields.includeBroken]: bool().optional(),
  [CrawlerAdvancedFields.includeExternal]: bool().optional(),
  [CrawlerAdvancedFields.includeOrphan]: bool().optional(),
  [CrawlerAdvancedFields.includeImages]: bool().optional(),
  [CrawlerAdvancedFields.includeFiles]: bool().optional(),
})

export type CrawlerSettingsSchemaType = InferType<typeof crawlerSettings>

export const crawlerFormSchema = object({
  [CrawlerFormFields.url]: string().url().required(),
  [CrawlerFormFields.advanced]: bool().optional().default(false),
  [CrawlerFormFields.options]:
    mixed<CrawlerSettingsSchemaType>(crawlerSettings).optional(),
  [CrawlerFormFields.specificRoute]: bool().optional().default(false),
  [CrawlerFormFields.onePage]: bool().optional().default(false),
})

export type CrawlerFormSchemaType = InferType<typeof crawlerFormSchema>

export const getFieldDetails = (
  t: (key: string) => string,
): Partial<
  Record<
    CrawlerAdvancedFields | CrawlerFormFields,
    {
      title: string
      description: string
      disabled?: boolean
      premium?: boolean
    }
  >
> => ({
  /* Crawler advanced options */
  [CrawlerAdvancedFields.isAsync]: {
    title: t('fields.isAsync'),
    disabled: true,
    premium: true,
    description: t('fields.isAsyncDesc'),
  },
  [CrawlerAdvancedFields.includeSubDomains]: {
    title: t('fields.includeSubdomains'),
    disabled: true,
    premium: true,
    description: t('fields.includeSubdomainsDesc'),
  },
  [CrawlerAdvancedFields.includeBroken]: {
    title: t('fields.includeBroken'),
    description: t('fields.includeBrokenDesc'),
  },
  [CrawlerAdvancedFields.includeExternal]: {
    title: t('fields.includeExternal'),
    description: t('fields.includeExternalDesc'),
  },
  [CrawlerAdvancedFields.includeOrphan]: {
    title: t('fields.includeOrphan'),
    disabled: true,
    description: t('fields.includeOrphanDesc'),
  },
  [CrawlerAdvancedFields.includeImages]: {
    title: t('fields.includeImages'),
    description: t('fields.includeImagesDesc'),
  },
  [CrawlerAdvancedFields.includeFiles]: {
    title: t('fields.includeFiles'),
    description: t('fields.includeFilesDesc'),
  },
  /* Crawler top level settings */
  [CrawlerFormFields.specificRoute]: {
    title: t('fields.specificRoute'),
    description: t('fields.specificRouteDesc'),
  },
  [CrawlerFormFields.onePage]: {
    title: t('fields.onePage'),
    description: t('fields.onePageDesc'),
  },
})
